import { FormikHelpers } from "formik";
import { useCreateUnit } from "./api/createUnit";
import CreateUnitForm from "./CreateUnitForm";


const CreateUnit = ({handleCloseModal}: CreateUnitProps)  => {
  const createUnitMutation = useCreateUnit({data: {}});

  const initialValues: ICreateUnitForm = {
    placeID: "",
    filepath: "",
    unID: "",
    sapCode: "",
    hubType: "",
    anetVoice: "",
    comments: "",
    isEmporiki: false,
    isCiti: false,
    description: "",
    deleted: false
  };

  const handleSubmit = async (values: ICreateUnitForm, { setSubmitting }: FormikHelpers<ICreateUnitForm>): Promise<void> => {
    try {
      await createUnitMutation.mutateAsync({
        data: values,
      });
      handleCloseModal();
    } catch (error) {
      console.log(error);
      console.log("values", values);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <CreateUnitForm initialValues={initialValues}  onSubmit={handleSubmit} />
  )
}

interface CreateUnitProps {
  handleCloseModal: () => void;
}

export default CreateUnit;